import { Typography, useMediaQuery } from "@mui/material";
import useLandingPageFooterStyles from "./styles";
import classNames from "classnames";
import { useIntl } from "react-intl";
import I18nKey from "translations/I18nKey";
function LandingPageFooter() {
  const classes = useLandingPageFooterStyles();
  const intl = useIntl();
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <>
      <Typography
        className={classNames(classes.footer, {
          mobile: isMobile,
        })}
      >
        {intl.formatMessage({
          id: I18nKey.LANDING_PAGE_MAIN_SECTION_FOOTER,
        })}
      </Typography>
    </>
  );
}

export default LandingPageFooter;
